module.exports = __webpack_public_path__ + "img/failed.908424fe.svg";